import React from "react";
import CommonInput from "../../../../components/forms/CommonInput";
import {
  handleChange,
  handleChangeNameValue,
  handleChangeUnmask,
} from "../../../../helpers/handleFormChanges";
import CommonInputMask from "../../../../components/forms/CommonInputMask";
import CommonRadioOpcoes from "../../../../components/forms/CommonRadioOpcoes";
import PropTypes from "prop-types";

function ClienteDadosCNPJ({ valuesHook, sent }) {
  const { values, setValues } = valuesHook;

  return (
    <>
      <div className="row">
        <div className="col-lg-4 mb-3">
          <CommonInputMask
            label="CNPJ"
            id="cnpj"
            value={values.cnpj}
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            mask="99.999.999/9999-99"
            required
            disabled
            sent={sent}
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonInput
            label="Razão social"
            id="razao_social"
            value={values.razao_social}
            onChange={(e) => handleChange(e, values, setValues)}
            required
            limit={75}
            sent={sent}
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonInput
            label="Nome fantasia"
            id="nome_fantasia"
            value={values.nome_fantasia}
            onChange={(e) => handleChange(e, values, setValues)}
            limit={75}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4 mb-3">
          <CommonInput
            label="Inscrição municipal"
            id="inscr_municipal"
            value={values.inscr_municipal}
            onChange={(e) => handleChange(e, values, setValues)}
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonInput
            label="E-mail"
            id="email"
            value={values.email}
            onChange={(e) => handleChange(e, values, setValues)}
            required
            type="email"
            sent={sent}
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonInputMask
            label="Celular"
            id="celular"
            value={values.celular}
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            mask={"(99)9 9999-9999"}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4 mb-3">
          <CommonInputMask
            label="Telefone"
            id="telefone"
            value={values.telefone}
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            mask={"(99)9999-9999"}
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonRadioOpcoes
            label="Optante Simples"
            id="optante_simples"
            upValue={values.optante_simples}
            lowValue={!values.optante_simples}
            upOnChange={(e) =>
              handleChangeNameValue(
                "optante_simples",
                e.target.checked,
                values,
                setValues
              )
            }
            lowOnChange={(e) =>
              handleChangeNameValue(
                "optante_simples",
                !e.target.checked,
                values,
                setValues
              )
            }
            upText="Sim"
            lowText="Não"
          />
        </div>
      </div>
    </>
  );
}

ClienteDadosCNPJ.propTypes = {
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  sent: PropTypes.bool.isRequired,
};

export default ClienteDadosCNPJ;
